export enum NecessaryCookies {
  CKIES_NECESSARY = 'ckies_necessary',
}

export enum FunctionalCookies {
  CKIES_FUNCTIONAL = 'ckies_functional',
}

export enum PerformanceCookies {
  CKIES_PERFORMANCE = 'ckies_performance',
}

export enum MarketingCookies {
  CKIES_MARKETING = 'ckies_marketing',
}

export type PermissionLevel = 'necessary' | 'functional' | 'performance' | 'marketing';
